export type QualityTVPlacements = 'TitlePage' | 'SearchPage' | 'HomePage' | 'SearchBox';

export const compositionIDSuffixByPlacement: Record<Exclude<QualityTVPlacements, 'TitlePage'>, string> = {
	SearchPage: 'sp',
	HomePage: 'hm',
	SearchBox: 'sb',
};

/**
 * SVOD - Subscription, TVOD - Rent / Buy, FREE - has Free Trial, JWTV - JustWatch TV
 */
type QtvType = 'SVOD' | 'TVOD' | 'FREE' | 'JWTV';

/**
 * Map of QTV providers by type.
 * These have different buybox requirements, like what to show under different Buybox Filter conditions.
 * TVOD & SVOD providers do not have a Free Trial - so we need to show a different provider & placement on titles with offers.
 */
export const qtvProvidersByType: Record<QtvType, string[]> = {
	SVOD: ['hst', 'sst', 'dnp', 'viu'],
	TVOD: ['itu'],
	FREE: ['atp', 'amp', 'prv', 'cru'],
	JWTV: ['jwt'],
};

/**
 * Returns the type of QTV provider based on the provider short name.
 */
export const qtvProviderType: Record<string, QtvType> = Object.fromEntries(
	Object.entries(qtvProvidersByType).flatMap(([type, providers]) =>
		providers.map(provider => [provider, type] as [string, QtvType])
	)
);

/**
 * List of all QTV providers with a defined QtvType.
 */
export const qtvProviders = Object.keys(qtvProviderType);
